export default "__VITE_PUBLIC_ASSET__8dec4110__"